import getOrCreateCustomerId from '@lib/customer';
import fetchApi from '@lib/fetchApi';
import getConfigProps from '@lib/getConfigProps';
import { getJobAlertPage } from '@lib/prepr';
import JobAlert from '@organisms/JobAlert/JobAlert';
import { isCorporateDomain } from '@utils/getDomain';
import PropTypes from 'prop-types';

function JobAlertPage({ page }) {
  return <JobAlert page={page} />;
}

JobAlertPage.propTypes = {
  page: PropTypes.shape({
    id: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired,
    introText: PropTypes.string,
    metaTitle: PropTypes.string,
    metaDescription: PropTypes.string,
  }).isRequired,
};

export async function getServerSideProps(ctx) {
  const { req, locale, preview = false } = ctx;

  const customerId = getOrCreateCustomerId(req);
  const { host } = req.headers;

  if (isCorporateDomain(host)) {
    return {
      notFound: true,
    };
  }

  const page = await getJobAlertPage({
    host,
    locale,
    customerId,
    preview,
  });

  if (!page) {
    return {
      notFound: true,
    };
  }

  const { error, data: filters } = await fetchApi({
    path: '/vacancies/all-filter-options',
  })
    .then(response => response)
    .catch(e => {
      console.error(e);
      return { error: { message: e.message } };
    });

  const {
    props: { config },
  } = await getConfigProps(ctx);

  if (error) {
    return {
      props: {
        page: {
          ...page,
          error,
        },
        config,
        host,
        preview,
        customerId,
      },
    };
  }

  return {
    props: {
      page: {
        ...page,
        filters,
      },
      config,
      host,
      preview,
      customerId,
    },
  };
}

export default JobAlertPage;
